import { Container, wrap } from 'AppReact';
import { HeaderWrapper, Wrapper } from './wrappers';
import { CloseButton, Title } from './atoms';
import { ModalCloseButton } from 'components/icons';
import { GenericWrapper } from 'wrappers';

const ModalHeader = Container({
  name: 'ModalHeader',
  props: {},
  elements: [
    {
      name: 'Header',
      wrapper: Wrapper,
      elements: [
        {
          name: 'TitleElement',
          wrapper: GenericWrapper,
          elements: [
            {
              component: Title,
              name: 'Title',
              bindings: () => ({}),
              displayValue: () => 'Email Already Exist',
            },
          ]
        },
        {
          wrapper: GenericWrapper,
          isButton: true,
          name: 'CloseButton',
          bindings: () => ({}),
          elements: [
            {
              component: CloseButton,
              name: 'Button',
              bindings: () => ({}),
              displayValue: () => ModalCloseButton({})
            }
          ]
        }
      ]
    }
  ]
})

export default wrap(ModalHeader, HeaderWrapper);
